import { render, staticRenderFns } from "./kv-tab.vue?vue&type=template&id=0119028e&scoped=true"
import script from "./kv-tab.vue?vue&type=script&lang=js"
export * from "./kv-tab.vue?vue&type=script&lang=js"
import style0 from "./kv-tab.vue?vue&type=style&index=0&id=0119028e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0119028e",
  null
  
)

export default component.exports